<div class="copyRight-mo">
  <div class="col-12 text-center">
    <p>
      جميع الحقوق محفوظة 1442هـ | 2021 م وزارة النقل المملكة العربية السعودية
    </p>
  </div>
</div>
